import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { useStaticQuery, graphql } from 'gatsby';

import { Helmet } from 'react-helmet';

import { createCloudinaryImageUrl } from '../../../../utils/cloudinaryUtils';

const getTitle = pageData => {
  let title = get(pageData, 'title');
  if (isEmpty(title)) {
    title = get(pageData, 'menuTitle');
  }
  return title;
};

const getHeroImageUrl = pageData => {
  const publicId = get(pageData, 'heroImage.cloudinaryImage.0.public_id');
  if (isEmpty(publicId)) {
    return undefined;
  }
  return createCloudinaryImageUrl('OgImage-MD-MD', publicId);
};

function ArticleStructuredData({ pageData }) {
  const query = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
          title
          description
          siteUrl
          defaultLanguage
        }
      }
    }
  `);

  const structuredData = useMemo(() => {
    return JSON.stringify({
      '@context': 'https://schema.org/',
      '@type': 'NewsArticle',
      headline: getTitle(pageData),
      datePublished: isEmpty(get(pageData, 'publishingDate'))
        ? get(pageData, 'createdAt')
        : get(pageData, 'publishingDate'),
      dateModified: get(pageData, 'updatedAt'),
      image: getHeroImageUrl(pageData),
      author: {
        '@type': 'Organization',
        name: get(query, 'site.siteMetadata.author'),
      },
    });
  }, [pageData, query]);

  return (
    <Helmet>
      <script type="application/ld+json">{structuredData}</script>
    </Helmet>
  );
}

ArticleStructuredData.propTypes = {
  pageData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

ArticleStructuredData.defaultProps = {
  pageData: null,
};

export default ArticleStructuredData;
